import React from 'react';
import { AlertCircle } from '@saleshandy/icons';

import Modal from '../../../../../shared/design-system/ui/modal';

interface PhoneNumberCartItem {
  phoneNumber: string;
  region: string;
  numberType: string;
  pricePerQuarter: string;
}

interface ClearAllPhoneNumberCartModalProps {
  show: boolean;
  onSubmit: () => void;
  onClose: () => void;
  phoneNumbers: PhoneNumberCartItem[];
  clearAllCartModalText: {
    title: string;
    description: string;
    buttons: {
      primary: string;
      secondary: string;
    };
  };
}

const ClearAllPhoneNumberCartModal: React.FC<
  ClearAllPhoneNumberCartModalProps
> = ({ show, onSubmit, onClose, clearAllCartModalText }) => {
  const { title, description:desc, buttons:{primary:primaryBtnLabel, secondary:secondaryBtnLabel} } = clearAllCartModalText;

  return (
    <Modal
      show={show}
      className="purchase-phone-number-confirmation-modal"
      title={
        <div className="d-flex align-items-center gap-10">
          <AlertCircle width={24} height={24} color="#D97706" />
          <span className="line-height-1">{title}</span>
        </div>
      }
      onHide={onClose}
      primaryBtnLabel={primaryBtnLabel}
      secondaryBtnLabel={secondaryBtnLabel}
      primaryBtnClickedHandler={onSubmit}
      secondaryBtnClickedHandler={onClose}
    >
      <p>{desc}</p>
    </Modal>
  );
};

export default ClearAllPhoneNumberCartModal;

